import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IUserAddress } from 'src/modules/authentication/interfaces/user-address.interface';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';
import { BroadcastJobsUtilService } from 'src/modules/company-dashboard/services/broadcast-job-utils.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-add-new-address',
  templateUrl: './add-new-address.component.html',
  styleUrls: ['./add-new-address.component.scss'],
})
export class AddNewAddressComponent implements OnInit {

  @Input() userData: IUser;  
  @Input() allAddressesOfCompany: IUserAddress[] = [];
  @ViewChild('googlePlaces', { static: false }) googlePlaceInput;
  @Output() updateUserAddress = new EventEmitter();
  formattedAddress: string;
  googlePlace: any;
    
  newformattedAddress: IUserAddress;

  constructor(
    private broadcastJobsUtilService: BroadcastJobsUtilService) { }

  ngOnInit() {}

  async addressUpdates() {
      // Google Places API auto complete
      const input = await this.googlePlaceInput.getInputElement();
      const autocomplete = new google.maps.places.Autocomplete(input, { types: [] });
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        // retrieve the place object for your use
        const place = autocomplete.getPlace();
        this.formattedAddress = place.formatted_address;
        this.googlePlace = place;
        const newformattedAddress: IUserAddress = this.broadcastJobsUtilService.getFormatedAddress(this.googlePlace);
        this.newformattedAddress = {
          longitude: newformattedAddress.longitude,
          latitude: newformattedAddress.latitude,
          city: newformattedAddress.city && newformattedAddress.city !== 'undefined'
            && newformattedAddress.city !== null ? newformattedAddress.city : this.userData.entityId.address.city,
          street: newformattedAddress.street,
          province: this.userData.entityId.address.province,
          default: false
        };
  
      });
    }
  

  saveNewAddress() {
    if (this.newformattedAddress) {
      this.updateUserAddress.emit(this.newformattedAddress); 
      this.newformattedAddress = null;
      this.formattedAddress = null;
    }
  }
}
